import { createStore } from "zustand/vanilla";
import { useStore } from "zustand";
import { recipes } from "../motion";

export interface Toast {
  id: number;
  message: string;
  actionLabel?: string;   // "Undo"
  onAction?: () => void;
  /** The toast left without its action being used (timed out, dismissed, or pushed out): commit what Undo would cancel. */
  onClose?: () => void;
}

interface ToastState {
  toasts: Toast[];
  show: (t: Omit<Toast, "id">) => number;
  /** `acted`: the action button was used, so onClose doesn't run. */
  dismiss: (id: number, acted?: boolean) => void;
}

let nextId = 1;

export const toastStore = createStore<ToastState>()((set, get) => ({
  toasts: [],
  show: (t) => {
    const id = nextId++;
    const pushed = get().toasts.slice(0, -2);
    set((s) => ({ toasts: [...s.toasts.slice(-2), { ...t, id }] })); // max 3 on screen
    for (const x of pushed) x.onClose?.();
    return id;
  },
  dismiss: (id, acted = false) => {
    const t = get().toasts.find((x) => x.id === id);
    set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) }));
    if (t && !acted) t.onClose?.();
  },
}));

export const useToasts = <T,>(selector: (s: ToastState) => T) => useStore(toastStore, selector);
export const AUTO_DISMISS_MS = recipes.toast.autoDismissMs;
